<div class="insight-box">
  <h3 class="insight-box__top">{{topText}}</h3>
  <div class="insight-box__bottom">{{bottomText}}</div>
</div>
